import { Box, CardMedia, Typography } from "@mui/material";

interface IProps {
  title: string;
  imageUrl: string;
}

const ResourcesCard: React.FC<IProps> = ({ title, imageUrl }) => {
  return (
    <>
      <Box
        sx={{
          width: "auto",
          height: { xs: 68, md: 145 },
          overflow: "hidden",
        }}
        mb={{ xs: 1.5, md: 3 }}
      >
        <CardMedia
          component="img"
          loading="lazy"
          image={imageUrl}
          alt={title}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </Box>
      <Typography
        variant="caption"
        component="p"
        color="text.primary"
        fontWeight={700}
        fontSize={{ xs: 8, md: 14 }}
        textAlign="center"
      >
        {title}
      </Typography>
    </>
  );
};

export default ResourcesCard;
